const style = document.createElement("style");
style.textContent = "#adCon, *[id*='aHider'] { display: none !IMPORTANT; }";

document.addEventListener("DOMContentLoaded", () => {
  document.documentElement.append(style);
});

const msg = "breaking krunker ad loading (ignore this)";

Object.defineProperty(window, "clearPops", {
  set: (v) => {
    delete window.clearPops;
    window.clearPops = v;
    window.canShowAds = false;
    window.useFRVRSDKAds = false;
    window.useFRVRSDKBannerAds = false;
    delete window.FRVR.config.ads;
    window.FRVR.init("prod");
    window.addEventListener(
      "error",
      (event) => {
        if (event.error?.message === msg) event.preventDefault();
      },
      { once: true },
    );
    throw new Error(msg);
  },
  configurable: true,
});
